import { render, staticRenderFns } from "./notice_table2.vue?vue&type=template&id=353e33f0&scoped=true&"
import script from "./notice_table2.vue?vue&type=script&lang=js&"
export * from "./notice_table2.vue?vue&type=script&lang=js&"
import style0 from "./notice_table2.vue?vue&type=style&index=0&id=353e33f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e33f0",
  null
  
)

export default component.exports